import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-48685963"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "html-contents" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "contents-line" }
const _hoisted_5 = {
  key: 0,
  class: "line-left"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left-title" }, " 相关分类： ", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "line-right"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "contents-right-title" }, "当前位置：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/free" }, "学习专区", -1))
const _hoisted_12 = {
  key: 0,
  class: "contents-info contents",
  id: "headerTop"
}
const _hoisted_13 = { class: "info-left-collection" }
const _hoisted_14 = { class: "info-right-title" }
const _hoisted_15 = { class: "right-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_17 = { class: "right-lable" }
const _hoisted_18 = {
  class: "info-right-list",
  id: "infoList"
}
const _hoisted_19 = {
  key: 0,
  class: "right-big-title"
}
const _hoisted_20 = { class: "list-item" }
const _hoisted_21 = { class: "list-title" }
const _hoisted_22 = { class: "list-info" }
const _hoisted_23 = {
  key: 1,
  class: "right-big-title right-big-technology"
}
const _hoisted_24 = { class: "list-item" }
const _hoisted_25 = { class: "list-title" }
const _hoisted_26 = { class: "list-info" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-xiala" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shangla" }, null, -1))
const _hoisted_29 = {
  key: 1,
  class: "contents-bottom contents"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_goods_swiper = _resolveComponent("goods-swiper")!
  const _component_free_goods_img = _resolveComponent("free-goods-img")!
  const _component_goods_collection = _resolveComponent("goods-collection")!
  const _component_lay_line = _resolveComponent("lay-line")!
  const _component_bottom_item = _resolveComponent("bottom-item")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.goodsList.datas && _ctx.goodsList.datas.options)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList.datas.options, (options, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "left-list",
                    onClick: ($event: any) => (_ctx.gotoClass(options.id))
                  }, _toDisplayString(options.name), 9, _hoisted_7))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_ctx.goodsList.datas && _ctx.goodsList.datas.options)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, [
                  _hoisted_10,
                  _createTextVNode(" > "),
                  _hoisted_11,
                  _createTextVNode(" > " + _toDisplayString(_ctx.goodsList.datas.name ? _ctx.goodsList.datas.name : "切段组件"), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.goodsList.datas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _withDirectives(_createElementVNode("div", {
                class: "large",
                style: _normalizeStyle([
							{
								backgroundImage: 'url(' + _ctx.nowImgUrl + ')',
								backgroundPosition: `-${_ctx.position.x * 2}px -${_ctx.position.y * 2}px`,
							},
						])
              }, null, 4), [
                [_vShow, !_ctx.fisOutside]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["info-left", { infoLeftSwiper: _ctx.swiperShow }])
              }, [
                (_ctx.goodsList.datas.old_pics.length > 1)
                  ? (_openBlock(), _createBlock(_component_goods_swiper, {
                      key: 0,
                      type: 1,
                      pics: _ctx.resetImg(),
                      onSetPosition: _ctx.setPosition
                    }, null, 8, ["pics", "onSetPosition"]))
                  : (_openBlock(), _createBlock(_component_free_goods_img, {
                      key: 1,
                      onSetPositionImg: _ctx.setPositionImg,
                      goodsImg: _ctx.goodsList.datas.old_pics[0]
                    }, null, 8, ["onSetPositionImg", "goodsImg"])),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.goodsList.datas.id)
                    ? (_openBlock(), _createBlock(_component_goods_collection, {
                        key: 0,
                        id: _ctx.goodsList.datas.id,
                        type: 2,
                        store: _ctx.goodsList.datas.store,
                        names: _ctx.goodsList.datas.name,
                        goods: _ctx.goodsList.datas,
                        cid: _ctx.goodsList.datas.cid
                      }, null, 8, ["id", "store", "names", "goods", "cid"]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["info-right", {
							'info-right-limt': _ctx.showmore,
							infoLeftSwiper: _ctx.swiperShow,
						}])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.goodsList.datas.name), 1),
                    _hoisted_16
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.goodsList.datas.desc), 1),
                  _createVNode(_component_lay_line)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (
									_ctx.goodsList.datas.type == 1 &&
									_ctx.goodsList.datas.designs.length > 0
								)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, " 规格特点 "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList.datas.contentArr, (arr, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(arr.title), 1),
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arr.content, (content, aindex) => {
                          return (_openBlock(), _createElementBlock("p", null, _toDisplayString(content), 1))
                        }), 256))
                      ])
                    ]))
                  }), 256)),
                  (
									_ctx.goodsList.datas.type == 1 &&
									_ctx.goodsList.datas.designs.length > 0
								)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, " 设计要点 "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList.datas.designs, (pic_c, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(pic_c.title), 1),
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pic_c.content, (content, aindex) => {
                          return (_openBlock(), _createElementBlock("p", null, _toDisplayString(content), 1))
                        }), 256))
                      ])
                    ]))
                  }), 256))
                ]),
                (_ctx.isShowHeight)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.showmore)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "showmore no-active",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toShowMore && _ctx.toShowMore(...args)))
                          }, [
                            _hoisted_27,
                            _createTextVNode("显示更多 ")
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "showmore",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toShowMore && _ctx.toShowMore(...args)))
                          }, [
                            _hoisted_28,
                            _createTextVNode("收起 ")
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.goodsList.datas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_bottom_item, {
                isFixed: _ctx.isFixed,
                isFixedBottom: _ctx.isFixedBottom,
                onUpdateHeight: _ctx.updateHeight,
                showType: _ctx.goodsList.datas.type,
                goodsname: _ctx.goodsList.datas.name,
                pic_cs: _ctx.getPicList()
              }, null, 8, ["isFixed", "isFixedBottom", "onUpdateHeight", "showType", "goodsname", "pic_cs"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.goodsList.datas)
      ? (_openBlock(), _createBlock(_component_html_footer, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}